import React from 'react';
import './NotificationModal.css';
import { Box, Button } from '@mui/material';
import { Link } from 'react-router-dom';

const NotificationModal = ({ notification, onClose }) => {
    
  return (
    <div className="notification-modal">
      <div className="modal-content">
        <button className="close-btn" onClick={onClose}>×</button>

        {/* Notification body */}
        <p>{notification.body}</p>

        {/* Assign Driver button */}
        <Button 
        className="assign-driver-btn"
            variant="contained" 
            sx={{bgcolor:'#3C7F10'}}
          >
                      <Link to='/pending-driver-allocation' style={{ textDecoration: 'none',color:'#fff' }}>
            Assign Driver
        </Link>
          </Button>
      </div>
    </div>
  );
};

export default NotificationModal;
